/** Progress control */

import { useCallback, useEffect, useState } from 'react'
import { LinearProgress, type LinearProgressProps } from '@tunasong/ui-lib'

export interface PlayerProgressProps extends LinearProgressProps {
  el?: HTMLAudioElement | null
  ref?: React.Ref<HTMLDivElement>
}

export const PlayerProgress = (props: PlayerProgressProps) => {
  const { el, ref: timelineRef, style, ...restProps } = props

  const [progress, setProgress] = useState(0)

  const handleProgress = useCallback((ev: Event) => {
    const { currentTime, duration } = ev.target as HTMLAudioElement
    const val = (1 - (duration - currentTime) / duration) * 100
    setProgress(Number.isFinite(val) ? val : 0)
  }, [])
  const handleEnded = useCallback(() => {
    setProgress(0)
  }, [])

  /** Events from the player */
  useEffect(() => {
    if (!el) {
      return
    }
    setProgress(0)
    el.addEventListener('seeking', handleProgress)
    el.addEventListener('timeupdate', handleProgress)
    el.addEventListener('ended', handleEnded)
    return () => {
      el.removeEventListener('seeking', handleProgress)
      el.removeEventListener('timeupdate', handleProgress)
      el.removeEventListener('ended', handleEnded)
    }
  }, [el, handleEnded, handleProgress])

  return (
    <LinearProgress
      {...restProps}
      style={{ ...style, minWidth: 50, width: '100%', height: 12 }}
      variant="determinate"
      value={progress}
      ref={timelineRef}
    />
  )
}
